import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    contasBancarias: [],
  },
  mutations: {
    carregar(state, contasBancarias) {
      state.contasBancarias = [];
      state.contasBancarias = contasBancarias;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/contas-bancarias?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, contaBancariaInfo) {
      try {
        if (contaBancariaInfo.id == "") {
          delete contaBancariaInfo.id;
          await securedAxios.post("/contas-bancarias", contaBancariaInfo);
        } else {
          var id = contaBancariaInfo.id;
          delete contaBancariaInfo.id;
          await securedAxios.put("/contas-bancarias/" + id, contaBancariaInfo);
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarContaBancaria(context, id) {
      return securedAxios.get(`/contas-bancarias/${id}`);
    },
    carregarContasBancarias() {
      return securedAxios.get("/contas-bancarias");
    },
    async carregarBancos() {
      return securedAxios.get("/bancos");
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete("/contas-bancarias/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async retornaDados(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/contas-bancarias?opcoes=${urljson(opcoes)}`
        );

        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
